import { jsx } from 'react/jsx-runtime';
import resource from '../utils/resource.mjs';

function StaticImage({ src, alt, srcSet, ...props }) {
  return /* @__PURE__ */ jsx(
    "img",
    {
      src: resource(src),
      alt,
      srcSet: srcSet?.map((v) => `${resource(v.src)} ${v.resolution}x`).join(", "),
      ...props
    }
  );
}

export { StaticImage as default };
//# sourceMappingURL=index.mjs.map
